var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpringside02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 272.9 190.4",
    enableBackground: "new 0 0 272.9 190.4",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M92.5,180.1h-2.4l-0.4,2.7h-2l2.2-12.5h3l2.1,12.5H93L92.5,180.1z M91.3,171.9l-0.9,6.3h1.9L91.3,171.9 L91.3,171.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M100.2,175.4v4.7c0,0.8,0.3,1,1.2,1c0.2,0,0.4,0,0.7,0v1.9c-0.3,0-0.5,0-0.8,0c-2.3,0-3-0.9-3-2.7v-4.9 h-1.4v-1.7h1.4v-2.3h2v2.3h1.8v1.7H100.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M105,170.4h2v3.7c0,0.6,0,1.1,0,1.8h0c0.2-1.7,0.9-2.5,2.2-2.5c1.3,0,1.9,0.8,1.9,2.5v6.9h-2v-6.2 c0-0.9-0.3-1.4-0.9-1.4c-0.8,0-1.2,0.5-1.2,1.6v6h-2V170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M116.4,170.4v12.5h-2v-12.5H116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M121.5,180.1c0,1,0.4,1.3,1.1,1.3s1.1-0.3,1.1-1.3v-0.3h2v0c0,2.1-1,3.2-3,3.2h-0.2c-2,0-3-1.1-3-3.4v-3 c0-2.3,1-3.4,3.1-3.4h0.1c2,0,3,1.1,3,3.4v2.1h-4.2V180.1z M121.5,176.4v1h2.2v-1c0-1-0.3-1.3-1.1-1.3 C121.8,175.1,121.5,175.4,121.5,176.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M131.7,175.4v4.7c0,0.8,0.3,1,1.2,1c0.2,0,0.4,0,0.7,0v1.9c-0.3,0-0.5,0-0.8,0c-2.3,0-3-0.9-3-2.7v-4.9 h-1.4v-1.7h1.4v-2.3h2v2.3h1.8v1.7H131.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M138.5,170.6v2.2h-2v-2.2H138.5z M138.5,173.6v9.2h-2v-9.2H138.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M141.6,179.8v-3c0-2.2,0.9-3.4,2.9-3.4h0.1c2,0,2.8,1.2,2.8,3.4v0.4h-1.9v-0.8c0-1-0.3-1.3-1-1.3 c-0.7,0-1,0.4-1,1.3v3.7c0,1,0.3,1.3,1,1.3c0.6,0,1-0.3,1-1.3v-0.7h1.9v0.4c0,2.1-0.8,3.4-2.7,3.4h-0.2 C142.4,183.1,141.6,181.9,141.6,179.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M155,179.3V174c0-2.6,1.1-3.8,3.2-3.8h0.1c2.1,0,3.1,1.2,3.1,3.8v0.9h-2v-1.2c0-1.3-0.3-1.7-1.2-1.7 c-0.8,0-1.2,0.5-1.2,1.7v5.8c0,1.2,0.3,1.8,1.2,1.8c0.8,0,1.2-0.5,1.2-1.8v-1.1h2v0.9c0,2.5-0.9,3.8-3,3.8h-0.2 C156,183.1,155,181.8,155,179.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M166.4,170.4v12.5h-2v-12.5H166.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M169.7,180.6v-6.9h2v6.3c0,0.9,0.3,1.3,0.9,1.3c0.8,0,1.2-0.5,1.2-1.6v-6h2v9.2h-2v-0.5c0-0.6,0-1.1,0-1.8 h0c-0.1,1.7-0.9,2.4-2.2,2.4C170.3,183,169.7,182.2,169.7,180.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M181,180.7L181,180.7c0,0.9,0,1.3,0,1.8v0.3h-2v-12.5h2v3.6c0,0.5,0,1,0,1.7h0c0.1-1.6,0.8-2.3,2.1-2.3 c1.4,0,2.1,0.8,2.1,2.5v4.7c0,1.6-0.7,2.4-2,2.4C181.9,183,181.2,182.4,181,180.7z M183.2,179.9v-3.4c0-0.9-0.3-1.3-1-1.3 c-0.7,0-1.1,0.5-1.1,1.6v2.8c0,1.1,0.4,1.6,1.1,1.6C182.8,181.2,183.2,180.8,183.2,179.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0.4,139.3v-1.4H7v1.9c0,3.3,1.1,4.2,3.6,4.2c2.8,0,3.3-0.9,3.3-3.8c0-3.1-0.6-3.5-5.5-6 c-5-2.5-7.9-4.3-7.9-9.6c0-5.5,3.3-8.2,9.7-8.2h0.5c6.6,0,9.6,3.3,9.6,9.1v1.1h-6.6v-1.5c0-3.3-1-4.4-3.5-4.4 c-2.3,0-3.3,0.9-3.3,3.3c0,2.9,1.5,3.7,5.5,5.8c5.4,2.7,8,4,8,9.8c0,6-2.8,8.7-9.6,8.7H10C3.2,148.4,0.4,145.4,0.4,139.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35,121.7h7.8c6.7,0,9.5,2.4,9.5,8.2c0,5.8-2.9,8.3-9.9,8.3h-1.9v9.6H35V121.7z M42.4,134.2 c3.1,0,4.3-1.1,4.3-4.2c0-3.1-1.1-4.1-4.3-4.1h-1.8v8.4H42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M76.3,147.8l-3.4-10.3H70v10.3h-5.5v-26h7.7c6.7,0,9.5,2.6,9.5,7.7c0,3.7-1.3,5.8-3.7,7l3.9,11.3H76.3z  M72,133.4c3.1,0,4.1-1,4.1-3.8c0-2.8-1.1-3.8-4.1-3.8h-2v7.6H72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M100.3,147.8h-5.5v-26h5.5V147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M114.2,121.7h5.6l6.9,16.1h0.1v-16.1h4.9v26h-5.6l-6.9-16.1h-0.1v16.1h-4.9V121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M145.3,140.3v-11.1c0-5.4,2.9-8,8.5-8h0.4c5.4,0,8,2.6,8,8v2H157v-2.5c0-2.6-0.9-3.6-3-3.6 c-2.2,0-3.1,1-3.1,3.6v12c0,2.6,0.9,3.7,3.1,3.7c2.1,0,3-1.1,3-3.7v-2.4h-3.3v-3.8h8.5v5.8c0,5.3-2.4,8-7.9,8h-0.6 C147.9,148.3,145.3,145.6,145.3,140.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M174.1,140.6v-1.2h5.5v1.6c0,2.8,0.9,3.6,3,3.6c2.3,0,2.8-0.8,2.8-3.2c0-2.6-0.5-3-4.6-5.1 c-4.2-2.1-6.6-3.6-6.6-8.1c0-4.7,2.8-6.9,8.2-6.9h0.4c5.6,0,8.1,2.8,8.1,7.7v1h-5.5v-1.3c0-2.8-0.9-3.7-3-3.7 c-2,0-2.8,0.8-2.8,2.8c0,2.4,1.2,3.1,4.6,4.9c4.6,2.3,6.7,3.4,6.7,8.3c0,5.1-2.3,7.4-8.1,7.4h-0.6 C176.5,148.3,174.1,145.8,174.1,140.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M209.2,147.8h-5.5v-26h5.5V147.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M223.2,121.7h7.8c7.1,0,9.9,2.6,9.9,8.7v8.6c0,6.1-2.7,8.7-9.6,8.7h-8V121.7z M230.8,143.6 c3.3,0,4.4-1,4.4-4.1v-9.4c0-3.2-1.1-4.2-4.4-4.2h-2.1v17.8H230.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M254.5,117h18v4.9h-11.7v7.8H271v4.9h-10.1v8.3h11.7v4.9h-18V117z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EF4233",
    d: "M41.4,54.1l3.1,8.8h-7.8C38.1,59.9,39.7,57,41.4,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EF4233",
    d: "M235,60.4l-0.9,2.5H49.4l-4.9-13.8v0c3.2-4.8,6.9-9.4,10.8-13.7h162.2C224.5,42.9,230.4,51.3,235,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE244C",
    d: "M56.7,110.5H43.8v0.1h-6.5v-0.1H25.9c0-1.5,0-3.1,0.1-4.6l6.5-18.4l1-2.8H29c0,0,0-0.1,0-0.1l3.9-11h15.4 l3.9,11.1h-4.5l1,2.8L56.7,110.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F93D66",
    points: "226.3,95 220.8,110.5 61.6,110.5 54.2,89.3 58.7,89.3 53.2,73.6 230.4,73.6 222.8,95  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE244C",
    d: "M247,110.5h-22.5l6-16.9l0.8-2.1h-3.4l4.4-12.4l1.9-5.5h4.9l1.9,5.5l4.4,12.4h-3.4l0.8,2.1l4.3,12.2v0 C247,107.4,247,109,247,110.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDB29",
    d: "M206.2,24.8C187.1,9.3,162.9,0,136.5,0S85.8,9.3,66.7,24.8H206.2z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EE244C",
    d: "M238.6,157.8H34.4c-0.8,0-1.5,0.7-1.5,1.5v0c0,0.8,0.7,1.5,1.5,1.5h204.2c0.8,0,1.5-0.7,1.5-1.5v0 C240.1,158.4,239.4,157.8,238.6,157.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#0BB68B",
    points: "248.7,110.9 224.3,110.9 224.5,110.5 230.4,93.6 231.2,91.5 227.8,91.5 232.1,79.1 234.1,73.6  236.5,66.6 239,73.6 240.9,79.1 245.3,91.5 241.8,91.5 242.6,93.6 246.9,105.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 110.9,
    fill: "#686868",
    width: 4.9,
    height: 5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 37.3,
    y: 110.5,
    fill: "#686868",
    width: 6.5,
    height: 6.6
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0BB68B",
    points: "56.7,110.5 24.4,110.5 26,105.9 32.5,87.5 33.5,84.7 28.9,84.7 29,84.6 32.9,73.6 34.8,68.2  40.6,51.7 41.4,54.1 44.5,62.9 46.4,68.2 48.3,73.6 52.2,84.7 47.6,84.7 48.6,87.5  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpringside02);
export default __webpack_public_path__ + "static/media/springside-02.1752c07349a9d5f31aeb10b2ec8e6d1c.svg";
export { ForwardRef as ReactComponent };